import { WrappedOrder } from '@/entities/WrappedOrder';
import { WrappedPair } from '@/entities/WrappedPair';
import { useWrappedOrderListByUser } from '@/features/account/orderHook';
import { useTradeStore } from '@/features/trade/store';
import { useChainId, useUserAddr } from '@/hooks/web3/useChain';
import { useMemo } from 'react';

/**
 * Hook to get and filter orders based on hideOtherPair setting
 * @param currentPair - Current trading pair
 * @returns Filtered array of orders
 */
export const useFilteredOrders = (currentPair: WrappedPair | undefined, isTradePage = true): WrappedOrder[] => {
  const chainId = useChainId();
  const userAddr = useUserAddr();
  const { hideOtherPair } = useTradeStore();
  const orders = useWrappedOrderListByUser(chainId, userAddr, false);

  return useMemo(() => {
    if (!orders) {
      return [];
    }
    if (!hideOtherPair || !currentPair || !isTradePage) {
      return orders;
    }
    return orders.filter((order) => order.rootPair?.id === currentPair.id);
  }, [orders, hideOtherPair, currentPair, isTradePage]);
};
